import { getJSON } from 'common/services/api'
import type { TFunction } from 'i18next'
import { NAMESPACE } from 'locale'
import { cqiConstants } from 'locale/cqi'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import BaseCQITable from './BaseCQITable'
import { CQI_BASE_URL, CQITabID, type TablesDataSource } from './utils'

const CQI_SAFE_URL = `${CQI_BASE_URL}/safe`

export type SafeDataFetched = {
  dailyActiveCarers: number
  incidentsRecorded: number
  missedTodos: number
}

const SafeTable = () => {
  const { t } = useTranslation(NAMESPACE.CQI)

  const { data, isLoading } = useQuery<{ result: SafeDataFetched }>(
    ['cqi', CQITabID.Safe],
    () => getJSON({ url: CQI_SAFE_URL })
  )

  return (
    <BaseCQITable
      dataSource={getSafeData(t, data?.result)}
      isLoading={isLoading}
      tabID={CQITabID.Safe}
    />
  )
}

export const getSafeData = (
  t: TFunction<string, undefined>,
  props: SafeDataFetched | undefined
): TablesDataSource[] => {
  let dailyActiveCarers: number | undefined
  let incidentsRecorded: number | undefined
  let missedTodos: number | undefined
  if (props) {
    if (props.dailyActiveCarers !== undefined) {
      const fixedString = props.dailyActiveCarers.toFixed(2)

      dailyActiveCarers = parseFloat(fixedString)
    }
    if (props.incidentsRecorded !== undefined) {
      incidentsRecorded = props.incidentsRecorded
    }
    if (props.missedTodos !== undefined) {
      missedTodos = props.missedTodos
    }
  }

  return [
    {
      key: t(cqiConstants.AVERAGE_DAILY_ACTIVE_CARERS),
      indicator: t(cqiConstants.AVERAGE_DAILY_ACTIVE_CARERS),
      timeframe: t(cqiConstants.ONE_MONTH),
      output: dailyActiveCarers
    },
    {
      key: t(cqiConstants.INCIDENTS_RECORDED),
      indicator: t(cqiConstants.INCIDENTS_RECORDED),
      timeframe: t(cqiConstants.SIX_MONTHS),
      output: incidentsRecorded
    },
    {
      key: t(cqiConstants.TODOS_MISSES),
      indicator: t(cqiConstants.TODOS_MISSES),
      timeframe: t(cqiConstants.ONE_MONTH),
      output: missedTodos
    }
  ]
}

export default SafeTable
